var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 209.001,
    viewBox: "0 0 209 209.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manufacturing",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M205.516,165.021H194.832L188.1,67.25A3.486,3.486,0,0,0,184.616,64h-20.9a3.486,3.486,0,0,0-3.484,3.247l-6.733,97.77h-7.2v-20.9a3.484,3.484,0,0,0-5.661-2.72l-29.173,23.338V144.121a3.483,3.483,0,0,0-5.66-2.72L76.634,164.739V144.121a3.483,3.483,0,0,0-5.66-2.72L41.8,164.739V144.121a3.484,3.484,0,0,0-5.279-2.985l-34.834,20.9A3.484,3.484,0,0,0,0,165.021v83.6A3.483,3.483,0,0,0,3.484,252.1H205.516A3.483,3.483,0,0,0,209,248.621V168.5A3.483,3.483,0,0,0,205.516,165.021ZM166.969,70.97h14.394l6.488,94.05h-27.37ZM118.432,245.137v-41.8h20.9v41.8Zm83.6,0H146.3V199.853a3.485,3.485,0,0,0-3.485-3.482H114.949a3.484,3.484,0,0,0-3.484,3.482v45.284H6.966V166.993l27.866-16.72v21.714a3.483,3.483,0,0,0,5.661,2.721L69.667,151.37v20.617a3.483,3.483,0,0,0,5.66,2.722L104.5,151.371v20.617a3.483,3.483,0,0,0,5.66,2.721l29.173-23.338V168.5a3.484,3.484,0,0,0,3.484,3.484h59.215v73.149Zm0,0",
    transform: "translate(0 -43.104)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M355.429,6.968a12.933,12.933,0,0,1,3.387,2.619,12.186,12.186,0,0,0,7.784,4.347,12.715,12.715,0,0,0,8.208-4.529,16.315,16.315,0,0,1,2.94-2.438c.717.032,2.595,1.79,3.6,2.734a11.665,11.665,0,0,0,7.54,4.233,13.6,13.6,0,0,0,8.751-4.8c.854-.8,2.146-2.017,2.4-2.166,1.87,0,2.3.62,3.449,2.278a8.809,8.809,0,0,0,7.7,4.688,3.483,3.483,0,0,0,0-6.966c-.7,0-.833-.048-1.965-1.683A10.294,10.294,0,0,0,400.04,0a11.185,11.185,0,0,0-7.168,4.055c-1.157,1.091-3.1,2.912-3.832,2.929a14.191,14.191,0,0,1-2.934-2.364A12.926,12.926,0,0,0,377.747,0a12.076,12.076,0,0,0-7.7,4.305A14.459,14.459,0,0,1,366.7,6.968a13.553,13.553,0,0,1-3.134-2.473A12.634,12.634,0,0,0,355.452,0a3.484,3.484,0,1,0-.023,6.968Zm0,0",
    transform: "translate(-237.02 0)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M81.418,490.668H67.483A3.483,3.483,0,0,0,64,494.15v20.9a3.482,3.482,0,0,0,3.483,3.484H81.418a3.483,3.483,0,0,0,3.482-3.484v-20.9A3.484,3.484,0,0,0,81.418,490.668Zm-3.485,20.9H70.966V497.636h6.966Zm0,0",
    transform: "translate(-43.1 -330.434)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M166.75,490.668H152.816a3.483,3.483,0,0,0-3.484,3.482v20.9a3.482,3.482,0,0,0,3.484,3.484H166.75a3.483,3.483,0,0,0,3.482-3.484v-20.9A3.484,3.484,0,0,0,166.75,490.668Zm-3.485,20.9H156.3V497.636h6.966Zm0,0",
    transform: "translate(-100.566 -330.434)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M252.082,490.668H238.148a3.483,3.483,0,0,0-3.484,3.482v20.9a3.483,3.483,0,0,0,3.484,3.484h13.934a3.483,3.483,0,0,0,3.482-3.484v-20.9A3.484,3.484,0,0,0,252.082,490.668Zm-3.485,20.9H241.63V497.636H248.6Zm0,0",
    transform: "translate(-158.031 -330.434)",
    fill: "#1c6bfe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/Manufacturing.64010a7c164675147a941531f7c59af7.svg";
export { ForwardRef as ReactComponent };